import React, { useMemo } from "react";
import { Clock } from "lucide-react";

// Generate time options statically to improve performance
const generateTimeOptions = interval => {
  const options = [];
  for (let h = 0; h < 24; h++) {
    for (let m = 0; m < 60; m += interval) {
      const hour24 = h.toString().padStart(2, "0");
      const minute = m.toString().padStart(2, "0");
      const value24 = `${hour24}:${minute}`;
      options.push({ value: value24, label: value24 });
    }
  }
  // Add specific end times
  if (!options.find(o => o.value === "11:59")) {
    options.push({ value: "11:59", label: "11:59" });
  }
  options.push({ value: "23:59", label: "23:59" });
  return options.sort((a, b) => a.value.localeCompare(b.value));
};

// Cache options
const DEFAULT_OPTIONS = generateTimeOptions(15);

const TimeSelect = ({ value, onChange, disabled, placeholder = "Select time", hasError, interval = 15 }) => {
  const timeOptions = useMemo(() => {
    if (interval === 15) return DEFAULT_OPTIONS;
    return generateTimeOptions(interval);
  }, [interval]);

  return (
    <div className="relative">
      <select
        value={value || ""}
        onChange={e => onChange(e.target.value)}
        disabled={disabled}
        className={`w-full h-10 px-3 pr-8 rounded-md border ${
          hasError ? "border-red-500 focus:ring-red-500" : "border-slate-200"
        } bg-slate-100 text-sm focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed appearance-none`}
      >
        <option value="" disabled>
          {placeholder}
        </option>
        {timeOptions.map(option => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <Clock className="absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400 pointer-events-none" />
    </div>
  );
};

export default TimeSelect;
